
import { Button } from "@/components/ui/button";
import { Heart, X } from 'lucide-react';

interface LocalFavoritesHeaderProps {
  favoritesCount: number;
  onClearFavorites: () => void;
  onCollapse: () => void;
}

export const LocalFavoritesHeader = ({ 
  favoritesCount, 
  onClearFavorites, 
  onCollapse 
}: LocalFavoritesHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        <Heart className="h-6 w-6 text-red-500 fill-current" />
        <h3 className="text-xl font-bold text-red-800">
          Jouw Favorieten ({favoritesCount})
        </h3>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onClearFavorites}
          className="text-red-600 border-red-300 hover:bg-red-100"
        >
          Alles wissen
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onCollapse}
          className="text-gray-600 border-gray-300 hover:bg-gray-100"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
